
















import Vue from "vue";
import { Component } from "vue-property-decorator";

@Component
export default class Labels extends Vue {
  // 知识点1 读取
  // TODO
  get tags() {
    return this.$store.state.tagList;
  }
  created() {
    this.$store.commit("fetchTag");
  }
  createTag() {
    const name = window.prompt("输入新增标签名")!;
    if (name === "") {
      window.alert("标签名不为空");
    } else if (name === null) {
      return;
    } else {
      this.$store.commit("createTag", name);
      window.alert("新建标签成功");
    }
  }
}
